import apiClient from "../apiClient";

const resource = "services";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getServiesDetails: id => apiClient.get(`${resource}/${id}/serviesDetails`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    ServiesDetails: (id, payload) => apiClient.put(`${resource}/${id}/serviesDetails`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
  
};
